import React from "react";
import { Link, useNavigate } from "react-router-dom";
import styles from "./Home.module.css";
import heroImg from "../assets/home1.png";
import PageBanner from "../components/PageBanner";
//import homeBanner from "../assets/home-banner.jpeg";
import homeBanner from "../assets/slide1.png";
//import Testimonials from "../components/Testimonials";
import CustomTitle from "../components/CustomTitle";
import PageBanner1 from "../components/PageBanner1";
import LocationFooter from "./LocationFooter";
import homeBanner1 from "../assets/7.jfif";
const Home = () => {
  const navigate = useNavigate();
  return (
    <>
      <PageBanner image={homeBanner} title="Home" />
      <section className={styles.homeHero}>
        <div className={styles.heroContent}>
          <CustomTitle>ABOUT KASIBHATLAWS</CustomTitle>
          <p>
            KASIBHATLAWS , a full-service law firm committed to delivering
            excellence in legal solutions. With a client-centric approach and an
            unwavering commitment to justice, we provide professional
            representation across diverse areas of practice, including civil,
            criminal, corporate, labor, commercial, mining, regulatory, and
            family law. Our mission is simple yet powerful: to protect your
            rights, support your business, and guide you through complex legal
            landscapes with clarity and confidence. Whether you are an
            individual seeking justice, a corporation aiming for compliance, or
            an entrepreneur shaping new ventures, we stand with you at every
            step.
          </p>
          {/*  <ul>
            <li>Client-Centered Advocacy</li>
            <li>Transparent Billing</li>
            <li> Pan-India Representation</li>

            <li>Courtroom Excellence</li>
            <li>In-House Counsellors</li>
          </ul> */}
          <div className={styles.heroBtns}>
            <Link to="/contact" className={styles.ctaButton}>
              For Further Information
            </Link>
            <Link to="/practice-areas" className={styles.ctaButtonblack}>
              View Services
            </Link>
          </div>
        </div>
        <img src={heroImg} alt="Lawyer" className={styles.heroImg} />
      </section>
      <section className={styles.practiceAreas}>
        <CustomTitle>Our Core Practice Areas </CustomTitle>
        <div className={styles.areasGrid}>
          <div className={styles.areaCard} onClick={() => navigate("/civil")}>
            <h3>Civil Law</h3>
            <p>
              We handle all civil disputes with legal precision — including
              property conflicts, contract enforcement, and tort litigation.
            </p>
          </div>

          <div className={styles.areaCard} onClick={() => navigate("/mining")}>
            <h3>Mining Law</h3>
            <p>
              We offer expert counsel to mining operators and contractors on
              lease acquisition, regulatory compliance, and environmental
              clearances.
            </p>
          </div>
          <div
            className={styles.areaCard}
            onClick={() => navigate("/corporate")}
          >
            <h3>Commercial & Corporate Law</h3>
            <p>
              Comprehensive legal solutions for business: contracts, M&A,
              dispute resolution, and regulatory compliance.
            </p>
          </div>
          <div className={styles.areaCard} onClick={() => navigate("/family")}>
            <h3>Family Law</h3>
            <p>
              Legal support for families with a focus on dignity, protection,
              and justice in sensitive matters.
            </p>
          </div>
          <div
            className={styles.areaCard}
            onClick={() => navigate("/criminal")}
          >
            <h3>Regulatory Compliance</h3>
            <p>
              Navigating India’s complex regulatory environment requires
              precision and foresight. Our regulatory practice focuses on
              sector-specific compliance, licensing, and interaction with
              statutory authorities.
            </p>
          </div>
          <div className={styles.areaCard} onClick={() => navigate("/labor")}>
            <h3>Labor & Employment Law</h3>
            <p>
              We advise employers and employees on the full spectrum of labor
              and employment law issues, ensuring fair practices and legal
              compliance in the workplace.
            </p>
          </div>
        </div>
      </section>{" "}
      <PageBanner1 image={homeBanner1} />
      {/*  <Testimonials /> 
     
      <LocationFooter />*/}
    </>
  );
};

export default Home;
